module.exports = __webpack_public_path__ + "static/media/1017514.beebac81.jpg";